
import axios from '../../helpers/axios';


export const deletedApplicationChangeProfile = (id) => axios.delete(`/applicationChangeProfile/delete/${id}`)
